import { ValidateEmailDirective } from 'directives/validateEmail';
import { IgnoreKeypress } from 'directives/ignoreKeypress';
import { FormatPhoneNumber } from 'directives/formatPhoneNumber';
import { InputContainer } from 'components/inputContainer/inputContainer';

import template from './contactInfoForm.html';

export const ContactInfoForm = angular
    .module('checkout.components.contactInfoForm', [
        ValidateEmailDirective,
        IgnoreKeypress,
        FormatPhoneNumber,
        InputContainer
    ]).component('contactInfoForm', {
        template,
        bindings: {
            model: '=',
            phoneNumberRequired: '<',
            emailInputDisabled: '<'
        },
        controller: class ContactInfoFormCtrl {
            constructor() {
                this.contactInfoModel = {};
                this.phoneIgnoreCharRegex = /[A-Za-z!@#$%^&*()/:=|{}:"'<>\\_+\-.,;/?]/;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/contactInfoForm/contactInfoForm.js